import Quill from '../core/quill';
import logger from '../core/logger';
import Module from '../core/module';
import _ from 'lodash';

const debug = logger('quill:storage');

class Storage extends Module {
  constructor(quill, options) {
    super(quill, options);
    const attachHandler = this.attach.bind(this);
    setTimeout(attachHandler, 0);
  }
  
  attach() {
    this.storageKey = this.quill.container.dataset.storage || 'draft';
    this.storageId = this.quill.container.dataset.id || 0;
    this.fieldSelector = this.quill.container.dataset.field || '#hidden-text';
    this.content = this.quill.getContents();
  
    const handler = this.draftSave.bind(this);
    this.quill.on(
      Quill.events.TEXT_CHANGE,
      handler,
    );
    
    const storageGroup = this.storageGet(this.storageId, true);
    if (storageGroup) {
      const draft = storageGroup[this.storageKey];
      if (this.storageId === this.storageGet('id') && this.quill.getContents() !== draft) {
        this.quill.setContents(draft);
      }
    }
    this.updateFieldValue();
  }
  
  storageSet(key, value) {
    try {
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      }
      localStorage.setItem(key, value);
      return !!localStorage.getItem(key);
    } catch (e) {
      return false;
    }
  }
  
  storageGet(key, object) {
    try {
      let value = localStorage.getItem(key);
      if (object) {
        value = JSON.parse(value);
      }
      return value;
    } catch (e) {
      return false;
    }
  }
  
  // storageDelete(key) {
  //   try {
  //     localStorage.removeItem(key);
  //     return true;
  //   } catch (e) {
  //     return false;
  //   }
  // }
  
  // draftClear() {
  //   this.storageDelete(this.storageKey);
  //   this.storageDelete('id');
  // }
  
  draftSave() {
    let content = this.quill.getContents();
    if (!_.isEqual(this.content.ops, content.ops)) {
      this.content = content;
      this.updateFieldValue();
      
      this.storageSet('id', this.storageId);
      let storageGroup = this.storageGet(this.storageId, true) || {};
      storageGroup[this.storageKey] = content;
      return this.storageSet(this.storageId, storageGroup);
    }
    
    return false;
  }
  
  preparedValue() {
    const node = this.quill.root.cloneNode(true);
    const elements = node.querySelectorAll('.editable_text > .editable_input');
    for (const element of elements) {
      element.parentNode.innerText = element.value;
    }
  
    const removeAttribute = function(node, attribute) {
      const elements = node.querySelectorAll('['+attribute+']');
      for (const element of elements) {
        element.removeAttribute(attribute);
      }
    };
    const removeClass = function(node, className) {
      const elements = node.querySelectorAll('.'+className);
      for (const element of elements) {
        element.classList.remove(className);
      }
    };
    const removeElement = function(node, selector) {
      const elements = node.querySelectorAll(selector);
      for (const element of elements) {
        element.remove();
      }
    };
  
    removeAttribute(node, 'contenteditable');
    removeAttribute(node, 'data-placeholder');
    removeAttribute(node, 'data-label');
    removeAttribute(node, 'data-title');
    removeClass(node, 'editable_text');
    removeClass(node, 'focus');
    removeClass(node, 'empty');
    removeElement(node, '.cursor_wrapper');
  
    for (const element of node.querySelectorAll('[class=""]')) {
      element.removeAttribute('class');
    }
  
    const tweetBlocks = node.querySelectorAll('tweet');
    if (tweetBlocks.length) {
      for (let tweetBlock of tweetBlocks) {
        tweetBlock.innerText = '';
      }
    }
  
    const instagramBlocks = node.querySelectorAll('instagram');
    if (instagramBlocks.length) {
      for (let instagramBlock of instagramBlocks) {
        instagramBlock.innerText = '';
      }
    }
  
    const galleries = node.querySelectorAll('.gallery');
    if (galleries.length) {
      for (let gallery of galleries) {
        const elements = gallery.querySelector('.flexbin');
        gallery.className = gallery.className + ' ' + elements.className;
        gallery.innerHTML = elements.innerHTML;
      }
    }
    
    const excursionsBlocks = node.querySelectorAll('.excursions');
    if (excursionsBlocks.length) {
      for (let excursionsBlock of excursionsBlocks) {
        excursionsBlock.classList.remove('edit');
        excursionsBlock.innerText = '';
      }
    }
    
    const asideToursBlocks = node.querySelectorAll('.aside-tours');
    if (asideToursBlocks.length) {
      for (let asideToursBlock of asideToursBlocks) {
        asideToursBlock.classList.remove('edit');
        asideToursBlock.innerText = '';
      }
    }
    
    const asideArticleBlocks = node.querySelectorAll('.aside-articles');
    if (asideArticleBlocks.length) {
      for (let asideArticleBlock of asideArticleBlocks) {
        asideArticleBlock.classList.remove('edit');
        asideArticleBlock.innerText = '';
      }
    }
    
    const asideWebArticleBlocks = node.querySelectorAll('.aside-web-articles');
    if (asideWebArticleBlocks.length) {
      for (let asideWebArticleBlock of asideWebArticleBlocks) {
        const webArticleContainer = document.createElement('div');
        asideWebArticleBlock.classList.remove('edit');
        asideWebArticleBlock.querySelectorAll('.container-list .article-card').forEach(function(el) {
          const article = document.createElement('div');
          article.setAttribute('data-url', el.dataset.url);
          article.setAttribute('data-image', el.querySelector('img').src);
          article.setAttribute('data-title', el.innerText);
          webArticleContainer.appendChild(article)
        });
        asideWebArticleBlock.innerHTML = webArticleContainer.innerHTML;
      }
    }
    
    return node.innerHTML;
  }
  
  updateFieldValue() {
    const field = document.querySelector(this.fieldSelector);
    if (!field) {
      debug.warn('Linked field doesn`t exists', this.fieldSelector);
    } else {
      field.value = this.preparedValue();
    }
  }
  
}

export default Storage;
